<template lang="pug">
	sfc-menu
</template>

<script>
import SfcMenu from '@/layouts/common/sfc-menu-slim-v2'
export default {
	components: {
		SfcMenu
	}
}
</script>
